<ng-container *ngIf="id > 0">
    <ng-container *ngIf="profile">
        <div id="master-profile-nav">
            <div class="master-left">
                {{ profile.first_name + ' ' + profile.last_name }}<br/>
                {{ profile.email }}
            </div>
            <div class="master-right">
                <button
                        (click)="openUserMeals(profile)"
                        type="button"
                        class="btn-meals btn btn-sm btn-primary btn-icon-text">
                    <i class="ti-apple btn-icon-prepend"></i>
                    {{ 'hraneniq' | localise }}
                </button>

                <button
                        (click)="router.navigate(['master/profiles/settings', profile.id])"
                        type="button"
                        class="btn-settings btn btn-sm btn-secondary btn-icon-text">
                    <i class="ti-settings btn-icon-prepend"></i>
                    {{ 'just_settings' | localise }}
                </button>

                <i class="icon-options-vertical"
                   style="font-size: 1.8rem; margin-left: 5px; color: #d89d03; cursor: pointer;"
                   [app-popup]="{
                                  templateRef: actionMoreButtons,
                                  position: 'bottom',
                                  arrowPosition: ['top', 'right'],
                                  paddingless: true,
                                  closeUponSelection: true
                                }"></i>
                <ng-template #actionMoreButtons>
                    <a class="dropdown-item preview-item" (click)="router.navigate(['master/profiles/subscriptions', profile.id])">
                        <div class="preview-thumbnail">
                            <div class="responsive-flex-wrapper">
                                <i class="ti-lock text-primary"></i>
                            </div>
                        </div>
                        <div class="preview-item-content">{{ 'access' | localise }}</div>
                    </a>

                    <a class="dropdown-item preview-item" (click)="openMessages(profile)">
                        <div class="preview-thumbnail">
                            <div class="responsive-flex-wrapper">
                                <i class="fa fa-wechat text-primary"></i>
                            </div>
                        </div>
                        <div class="preview-item-content">{{ 'messages' | localise }}</div>
                    </a>
                </ng-template>
            </div>
            <div class="master-clear"></div>
        </div>
    </ng-container>

    <section id="settings" class="content">
        <div class="form-group">
            <label class="font-weight-bold">{{ 'title' | localise }}</label>
            <input type="text" name="title" (change)="onTitleChange($event)" class="form-control"/>
        </div>
        <div class="form-group">
            <label class="font-weight-bold">{{ 'note' | localise }}</label>
            <div #summernote [ngxSummernote] (summernoteModelChange)="change($event)"></div>
        </div>
        <div>
            <button (click)="save()" class="btn btn-block btn-primary">{{ 'save' | localise }}</button>
        </div>
    </section>
</ng-container>
